import { render, staticRenderFns } from "./eventodds.vue?vue&type=template&id=389e55dc&scoped=true"
import script from "./eventodds.vue?vue&type=script&lang=js"
export * from "./eventodds.vue?vue&type=script&lang=js"
import style0 from "./eventodds.vue?vue&type=style&index=0&id=389e55dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389e55dc",
  null
  
)

export default component.exports